import { render, staticRenderFns } from "./BasicDetailsSection.vue?vue&type=template&id=0b43de1b&scoped=true"
import script from "./BasicDetailsSection.vue?vue&type=script&lang=js"
export * from "./BasicDetailsSection.vue?vue&type=script&lang=js"
import style1 from "./BasicDetailsSection.vue?vue&type=style&index=1&id=0b43de1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b43de1b",
  null
  
)

export default component.exports